// Resolução de assets estáticos servidos a partir de `public/`.
// (No protótipo antigo havia window.__resources p/ blobs inline; aqui é tudo `public/`.)
export const asset = (name: string): string => `/${name}`
